<template>
  <pl-dialog
    :title="'Draft Assessments'"
    :size="'lg'"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <div class="pt-3 flex-grow overflow-auto">
      <div
        v-for="(d, index) in draftEvaluations"
        :key="index"
        class="border-b mb-5 px-7"
      >
        <div class="flex items-center mb-4 mt-3">
          <img
            v-if="revealNames"
            :src="d.user.avatar_url"
            class="rounded-full w-7 h-7"
          />
          <img
            v-else
            :src="d.anonymous_identity.avatar_url"
            class="rounded-full w-6 h-6"
          />
          <span
            v-if="revealNames"
            class="text-base text-gray-700 mx-3 font-semibold"
          >
            {{ d.user.name }}
          </span>
          <span v-else class="text-base text-gray-700 mx-3 font-semibold">
            {{ d.anonymous_identity.name }}
          </span>
        </div>
        <div v-if="d.draft_assessments.length">
          <div
            v-for="(a, index) in d.draft_assessments"
            class="flex items-center justify-between p-2.5 border-b border-solid border-gray-200"
            :key="index"
          >
            <span>{{ a.title }}</span>
            <span
              class="flex justify-center items-center h-6 w-12 rounded border border-solid border-gray-200"
            >
              {{ a.value }}
            </span>
          </div>
          <div class="flex items-center justify-between font-medium p-2.5">
            <span>Total Points</span>
            <div class="flex justify-center">
              <span
                class="flex justify-center items-center h-6 w-12 rounded border border-solid border-gray-200"
              >
                {{ totalPoints(d.draft_assessments) }}
              </span>
            </div>
          </div>
        </div>
        <div v-else class="my-2.5 font-medium">
          No criterias in draft mode for this student
        </div>
        <div
          v-if="d.draft_evaluation"
          class="mt-5 mb-8 px-4 py-3 w-full rounded border border-solid bg-gray-100 text-gray-600"
        >
          {{ d.draft_evaluation }}
        </div>
        <div v-else class="my-5 font-medium">
          There is currently no feedback here...
        </div>
      </div>
    </div>
    <footer class="px-7 py-4 flex justify-end">
      <button
        :disabled="loading"
        @click="sendEvaluations"
        class="flex bg-primary px-5 py-2 text-white font-semibold rounded"
      >
        Send Draft Assessments ({{ draftEvaluations.length }})
        <div class="loader" v-show="loading"></div>
      </button>
    </footer>
  </pl-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';

  export default {
    components: {},
    props: {
      draftEvaluations: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      ...mapGetters(['getProfile', 'getCourseDetail', 'getCurrentRT']),
      revealNames() {
        return (
          this.getCurrentRT.reveal_names || !this.getCurrentRT.enable_annonymous
        );
      },
    },
    methods: {
      totalPoints(draft_assessments) {
        return draft_assessments
          .map((a) => Number(a.value))
          .reduce((x, y) => x + y);
      },
      sendEvaluations() {
        this.loading = true;
        const payload = this.draftEvaluations.map((s) => {
          const submission = {};
          submission.id = s.id;
          submission.user_id = s.user_id;
          submission.draft_assessments = s.draft_assessments;
          submission.draft_evaluation = {
            grade: 0,
            comment: s.draft_evaluation,
            auto_save: false,
          };
          return submission;
        });
        this.$store
          .dispatch('sendEvaluations', {
            id: this.getCurrentRT.id,
            payload,
          })
          .then(async () => {
            this.loading = false;
            const toast = {
              type: 'Success',
              message: 'Assessments submitted with success! ',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            this.$emit('close');
            await this.$store.dispatch('fetchRoundtable', this.getCurrentRT.id);
          })
          .catch((err) => {
            this.loading = false;
            console.error(err);
          });
      },
    },
  };
</script>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// draftEvaluationsModal.vue?6e74936b